export const yesNoOptions = [
    { value: true, label: 'Tak' },
    { value: false, label: 'Nie' }
];